import { Alert, SimpleGrid } from '@chakra-ui/react';
import { memo } from 'react';

import CatalogItem from '@features/marketplace/catalog/CatalogItem';
import { OverridesStateContextProvider } from '@features/marketplace/catalog/context';
import { ProductDetails } from 'helpers/fakeData';
import { useStores } from 'stores/rootStore';

interface Props {
  products: ProductDetails[];
  hideAddToCart?: boolean;
}

const CatalogGrid = ({ products, hideAddToCart }: Props) => {
  const { marketPlaceStore } = useStores();
  const hasFilters =
    marketPlaceStore.selectedPriceRangeIds.length > 0 ||
    marketPlaceStore.selectedFilterAttributeIds.length > 0;

  if (products.length === 0) {
    return (
      <Alert.Root status="info" variant="outline" colorPalette="gray">
        <Alert.Indicator />
        <Alert.Title>
          {hasFilters ? 'No products match your selected filters' : 'No products available'}
        </Alert.Title>
      </Alert.Root>
    );
  }

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 4 }} gap={4} w="full">
      {products.map((item) => (
        <OverridesStateContextProvider key={item.id}>
          <CatalogItem key={item.id} item={item} hideAddToCart={hideAddToCart} />
        </OverridesStateContextProvider>
      ))}
    </SimpleGrid>
  );
};

export default memo(CatalogGrid);
